
import { defineComponent, ref } from 'vue';
import type { RouteRecordName } from 'vue-router';
import { useRoute } from 'vue-router';

import axios from 'axios';

import Image from '@hems/component/src/image/Image.vue';
import { TermsService } from '@hems/service';
import { TERMS_TYPE } from '@hems/util/src/constant/terms';

export default defineComponent({
  name: 'TermsPage',
  components: {
    Image,
  },
  setup() {
    const route = useRoute();
    const termsTitle: RouteRecordName = route.name ?? '';

    const axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
    const termsService = new TermsService(axiosInstance);

    const terms = ref<string>('');

    const getTermsList = async () => {
      try {
        const termsList = await termsService.getTerms(TERMS_TYPE.USER);
        terms.value = termsList.find((terms) => terms.terms_nm === termsTitle)?.terms_contents ?? '';
      } catch (e) {
        console.error(e);
      }
    };

    getTermsList();

    return {
      termsTitle,
      terms,
    };
  },
});
